import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { BuilderContextProvidersRegistry } from './builderContextProvidersRegistry'
import { BuilderFunctionLibraryRegistry } from './functionLibraryRegistry'
import { BuilderContextProvidersLoader } from './builderContextProvidersLoader'
import { BuilderContextProvidersPageWillMountHandler } from './builderContextProvidersPageWillMountHandler'
import {
	ContextProviderLoaderSymbol,
	ContextProviderRegistrySymbol,
	FunctionLibraryRegistrySymbol,
	BuilderModuleLoaderSymbol,
} from './symbols'
import { ClientBuilderModuleLoader } from './clientModuleLoader'
import { ImportMapProviderSymbol, LifeCycle, ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import {
	ContextProviderService,
	ContextBindingService,
	NoopContextBindingService,
	NoopContextProviderService,
} from './services'
import { ComponentWrapperSymbol } from '@wix/thunderbolt-components-loader'
import { ContextProviderWrapper } from './ContextProviderWrapper'
import { ContextBindingWrapper } from './ContextBindingWrapper'
import { BuilderContextProvidersImportMapProvider } from './importMapProvider'

export const bindCommonSite: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(NoopContextProviderService)
	bind(ServiceProviderSymbol).to(NoopContextBindingService)
	bind(ContextProviderRegistrySymbol).to(BuilderContextProvidersRegistry)
	bind(FunctionLibraryRegistrySymbol).to(BuilderFunctionLibraryRegistry)
	bind(ComponentWrapperSymbol).to(ContextProviderWrapper)
	bind(ComponentWrapperSymbol).to(ContextBindingWrapper)
	bind(ImportMapProviderSymbol).to(BuilderContextProvidersImportMapProvider)
}

export const site: ContainerModuleLoader = (bind) => {
	bindCommonSite(bind)
	bind(BuilderModuleLoaderSymbol).to(ClientBuilderModuleLoader)
	bind(ContextProviderLoaderSymbol).to(BuilderContextProvidersLoader)
}

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler).to(BuilderContextProvidersPageWillMountHandler)
	bind(ServiceProviderSymbol).to(ContextProviderService)
	bind(ServiceProviderSymbol).to(ContextBindingService)
}
